import React from "react";
import classes from "./WidgetPlaceholder.module.scss";

export const WidgetPlaceholder = () => (
  <div className={classes.widgetPlaceholder}>Not available.</div>
);
